import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { WorkinghoursTypeResolverPipe } from "@app/_pipes/workinghours-type-resolver.pipe";
import { TranslateService } from "@ngx-translate/core";
import { ClientsQuery, ProjectsQuery, UserSettingsQuery } from "@timeghost/web-api";
import { FormatPipe } from "ngx-date-fns";
import { AbsenceTranslatePipe } from "./absence-translate.pipe";
import { ArrayFlatPipe } from "./array-flat.pipe";
import { ArraySortPipe } from "./array-sort.pipe";
import { ClampPipe } from "./clamp.pipe";
import { ClsxPipe } from "./clsx.pipe";
import { CustomCurrencyPipe } from "./custom-currency.pipe";
import { DefaultEntityTranslatePipe } from "./default-entity-translate.pipe";
import { DfnsFormatTzPipe } from "./dfns-format-tz.pipe";
import { DfnsToZonedTimePipe } from "./dfns-to-zoned-time.pipe";
import { FallbackPipe } from "./fallback.pipe";
import { FormatDatePipe } from "./format-date.pipe";
import { GroupTranslatePipe } from "./group-translate.pipe";
import { IterateObjectPipe } from "./iterate-object/iterate-object.pipe";
import { JoinStringPipe } from "./join-string.pipe";
import { KeyValStorePipe } from "./key-val-store.pipe";
import { LengthPipe } from "./length.pipe";
import { MapPropPipe } from "./map-prop.pipe";
import { PadLeftPipe } from "./pad-left.pipe";
import { PadRightPipe } from "./pad-right.pipe";
import { ParseMsAsDurationPipe } from "./parse-ms-as-duration.pipe";
import { ProjectProxyPipe } from "./project-proxy.pipe";
import { ReplaceStringPipe } from "./replace-string.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { SafeUrlPipe } from "./safe-url/safe-url.pipe";
import { SplitPipe } from "./split.pipe";
import { TranslateArgsPipe } from "./translate-args.pipe";
import { TrimPipe } from "./trim.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { UniqByPipe } from "./uniq-by.pipe";

@NgModule({
	declarations: [
		SafeUrlPipe,
		SafeHtmlPipe,
		IterateObjectPipe,
		KeyValStorePipe,
		ParseMsAsDurationPipe,
		DfnsFormatTzPipe,
		JoinStringPipe,
		MapPropPipe,
		TruncatePipe,
		FormatDatePipe,
		DfnsToZonedTimePipe,
		SplitPipe,
		SafeHtmlPipe,
		DefaultEntityTranslatePipe,
		CustomCurrencyPipe,
		PadLeftPipe,
		PadRightPipe,
		ClampPipe,
		GroupTranslatePipe,
		AbsenceTranslatePipe,
		ReplaceStringPipe,
		ArrayFlatPipe,
		ArraySortPipe,
		ProjectProxyPipe,
		TranslateArgsPipe,
		TrimPipe,
		FallbackPipe,
		WorkinghoursTypeResolverPipe,
		LengthPipe,
	],
	imports: [CommonModule, ClsxPipe, UniqByPipe],
	providers: [
		{
			provide: DefaultEntityTranslatePipe,
			deps: [ProjectsQuery, ClientsQuery, TranslateService],
		},
		{
			provide: WorkinghoursTypeResolverPipe,
			deps: [UserSettingsQuery, TranslateService],
		},
		FormatPipe,
	],
	exports: [
		SafeUrlPipe,
		SafeHtmlPipe,
		IterateObjectPipe,
		KeyValStorePipe,
		ParseMsAsDurationPipe,
		JoinStringPipe,
		MapPropPipe,
		TruncatePipe,
		FormatDatePipe,
		DfnsFormatTzPipe,
		DfnsToZonedTimePipe,
		DefaultEntityTranslatePipe,
		CustomCurrencyPipe,
		PadLeftPipe,
		PadRightPipe,
		ClampPipe,
		GroupTranslatePipe,
		AbsenceTranslatePipe,
		ReplaceStringPipe,
		ArrayFlatPipe,
		ArraySortPipe,
		ProjectProxyPipe,
		TranslateArgsPipe,
		TrimPipe,
		FallbackPipe,
		ClsxPipe,
		UniqByPipe,
		WorkinghoursTypeResolverPipe,
		LengthPipe,
	],
})
export class CustomPipesModule {}
